import { Button, Modal } from '@dev-spendesk/grapes';

import { useFeature } from 'src/core/common/hooks/useFeature';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import FEATURES from 'src/core/constants/features';

type WireTransfersApprovedModalProps = {
  count: number;
  isOpen: boolean;
  onComplete: () => void;
};

export const WireTransfersApprovedModal = ({
  count,
  isOpen,
  onComplete,
}: WireTransfersApprovedModalProps) => {
  const isInstantPaymentEnabled = useFeature(FEATURES.TMP_INSTANT_PAYMENT);

  const { t } = useTranslation('global');

  const title = t(
    isInstantPaymentEnabled
      ? 'submitMyInvoice.scheduled.wireTransfer.transfersConfirmedTitle_instantPayment'
      : 'submitMyInvoice.scheduled.wireTransfer.transfersConfirmedTitle',
    {
      count,
    },
  );

  const body = isInstantPaymentEnabled
    ? t('submitMyInvoice.scheduled.wireTransfer.transfersConfirmedDescription')
    : null;

  return (
    <Modal
      actions={[
        <Button
          key="continue"
          text={t('submitMyInvoice.scheduled.wireTransfer.continue')}
          variant="primaryBrand"
          onClick={onComplete}
        />,
      ]}
      iconName="arrow-left-right"
      iconVariant="info"
      title={title}
      isOpen={isOpen}
    >
      {body}
    </Modal>
  );
};
